/* Green Hunters, Hero-Slider (Schicht A). Minimal, kein Autoplay, IIFE, defer. */
(function () {
  'use strict';

  function initHero(root) {
    var track = root.querySelector('.gh-hero__track');
    var slides = root.querySelectorAll('.gh-hero__slide');
    if (!track || slides.length <= 1) return;
    var dots = root.querySelectorAll('.gh-hero__dot');
    var n = slides.length;
    var i = 0;

    function go(idx) {
      i = (idx % n + n) % n;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      for (var k = 0; k < dots.length; k++) {
        var active = k === i;
        dots[k].classList.toggle('is-active', active);
        dots[k].setAttribute('aria-selected', active ? 'true' : 'false');
      }
    }

    var prev = root.querySelector('[data-gh-hero-prev]');
    var next = root.querySelector('[data-gh-hero-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    for (var d = 0; d < dots.length; d++) {
      (function (k) { dots[k].addEventListener('click', function () { go(k); }); })(d);
    }

    // Swipe (Touch)
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    }, { passive: true });

    // Tastatur
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(i - 1);
      else if (e.key === 'ArrowRight') go(i + 1);
    });

    go(0);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-gh-hero]');
    for (var i = 0; i < roots.length; i++) initHero(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
